module.exports = {
  title: '系统配置详情',
  route: {
    path: '/admin-system-manage',
    children: {
      path: 'system-config-form',
    },
  },
};
